/** Player ship base values. Upgrades layer multipliers on top of these. */
export const PLAYER = {
  /** Collision radius (walls/contact) */
  radius: 18,
  /** Ship sprite scale — brings the 128px canvas down to a ~45px visual,
   *  so the visual matches the collision radius */
  visualScale: 0.45,
  /** Actual bullet hitbox = radius * hitboxScale (bullet-hell fairness) */
  hitboxScale: 0.55,
  /** Boss body contact uses this share of the collision radius */
  contactScale: 0.7,

  // Movement
  accel: 3200,
  maxSpeed: 430,
  /** Friction: velocity decay when there is no input (exponential factor) */
  friction: 8,
  /** Nose turn smoothing (lerp factor) */
  turnLerp: 18,

  /** Muzzle forward offset from ship center */
  muzzleOffset: 22,

  // Dash / dodge (shared cooldown)
  dash: {
    speed: 1300,
    duration: 0.15,
    cooldown: 1.4,
    iframes: 0.22,
  },

  // Health / energy — numeric 100 HP model (docs/12 C1):
  // battery = cells of 25 HP, each cell drawn as 5 ticks of 5 HP
  maxHp: 100,
  /** A NEW game launches wounded — repair is the first goal (docs/12 L2) */
  startHp: 25,
  cellHp: 25,
  /** Extra hull cells from cards cap the total at 150 HP */
  maxBonusCells: 2,
  /** Armor units cap (yellow layer — one unit eats one hit) */
  maxArmor: 9,
  /** Invulnerability after taking a hit (s) */
  iframesOnHit: 1.0,
  maxEnergy: 100,
  /** Supershot energy per landed hit */
  energyPerHit: 2,

  /** Critical hits (docs/12 F1): rolled per projectile at fire time */
  crit: {
    baseChance: 0.05,
    baseDamageMul: 1.5,
  },
} as const;
